<script setup lang="ts">
definePageMeta({
  name: "search",
  title: "Søk",
  layout: "search",
})

const route = useRoute<"search">()
const { loading, results, totalCounts, filteredCounts, loadMore } = useContentSearch()
const productVariants = useProductVariantsStore()

const productLink = computed(() => "/produkter/" + route.params.product + "/" + route.params.variant)
</script>

<template>
  <div class="text-white min-h-dvh font-national2">
    <div
      class="grid grid-cols-1 lg:grid-cols-16 gap-6 mb-6 lg:mb-12"
    >
      <div class="hidden lg:block lg:col-span-4">
        <ULogo :dark="false" :product="productVariants.activeProduct" />
      </div>
      <header class="col-span-1 lg:col-span-11 lg:col-start-6 lg:grid-cols-subgrid lg:grid">
        <div class="flex items-center justify-between mb-8 lg:mb-10 col-span-full">
          <h2
            class="text-paywall-mobile-title md:text-paywall-desktop-title font-national2condensed"
          >
            Søk
            <span class="sr-only"
              >i {{ productVariants.activeProduct?.productTitle }}</span
            >
          </h2>
          <UButtonNew
            size="xs"
            circle
            variant="quite"
            :aria-label="`Lukk søk og gå tilbake til hovedsiden til ${productVariants.activeProduct?.productTitle}`"
            :to="productLink"
            class="text-white !p-0"
          >
            <template #prepend
              ><UIcon
                name="close"
                class="p-2 border-2 border-white rounded-full hover:border-u-contrast"
              />
            </template>
          </UButtonNew>
        </div>
        <USearchBar variant="light" class="lg:col-span-10" />
      </header>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-16 gap-6">
      <SearchFilters class="w-full lg:col-span-4" role="search" aria-label="Filter" />
      <main class="w-full lg:col-span-10 lg:col-start-6 mb-8">
        <div
          v-if="loading && results.data.length === 0"
          class="flex flex-col items-center justify-center py-16"
        >
          <UBookLoader />
          <p class="font-national2 text-2xl text-white mt-5">
            Laster inn...
          </p>
        </div>
        <USearchResultsList
          v-else
          :loading="loading"
          :results="results.data"
          :total-counts="totalCounts"
          :filtered-counts="filteredCounts"
          @load-more="loadMore"
        />
      </main>
    </div>
  </div>
</template>
